import React from 'react';

import styles from './contestJudgeStyles';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Link, { LINK_TYPES } from 'buyside/components/presentation/Link/link';

const Judge = ({
  judge: {
    sanitizedDisplayName,
    sanitizedProfilePictureUrl,
    sanitizedProfileUrl,
    sanitizedEmployerString,
    sanitizedEmployerUrl
  }
}) => {
  return (
    <span className={styles.judgeContainer}>
      <ProfileImage
        source={sanitizedProfilePictureUrl}
        size={'smaller'}
        style={styles.profileImage}
      />
      <div>
        {sanitizedProfileUrl ? (
          <Link to={sanitizedProfileUrl} type={LINK_TYPES.PLAIN} className={styles.displayName}>
            {sanitizedDisplayName}
          </Link>
        ) : (
          <span className={styles.displayName}>{sanitizedDisplayName}</span>
        )}
        {sanitizedEmployerUrl ? (
          <Link to={sanitizedEmployerUrl} type={LINK_TYPES.PLAIN} className={styles.employerString}>
            {sanitizedEmployerString}
          </Link>
        ) : (
          <span className={styles.employerString}>{sanitizedEmployerString}</span>
        )}
      </div>
    </span>
  );
};

export default Judge;
